import { IconButton, IconButtonProps, SvgIcon } from "@mui/material";

const LINE_TRANSITION = "transform 300ms cubic-bezier(0.25, 0.1, 0.35, 1)";
const MIDDLE_LINE_TRANSITION = "opacity 100ms";
const DIAGONAL_LINE_SCALE = Math.SQRT2;

interface IHamburgerProps extends IconButtonProps {
    isOpen: boolean;
}

export const Hamburger = ({ isOpen, ...iconButtonProps }: IHamburgerProps) => (
    <IconButton variant="ghost" {...iconButtonProps}>
        <SvgIcon
            viewBox="0 0 24 24"
            data-open={isOpen}
            sx={{
                width: "24px",
                height: "24px",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                "& line": { transformBox: "fill-box", transformOrigin: "center" },
                "& .top-line, & .bottom-line": { transition: LINE_TRANSITION },
                "& .middle-line": { transition: MIDDLE_LINE_TRANSITION },
                '&[data-open="true"]': {
                    "& .top-line": { transform: `translateY(6px) rotate(-45deg) scaleX(${DIAGONAL_LINE_SCALE})` },
                    "& .middle-line": { opacity: 0 },
                    "& .bottom-line": { transform: `translateY(-6px) rotate(45deg) scaleX(${DIAGONAL_LINE_SCALE})` },
                },
            }}
        >
            <line className="top-line" x1="5" y1="6" x2="19" y2="6" />
            <line className="middle-line" x1="11" y1="12" x2="19" y2="12" />
            <line className="bottom-line" x1="5" y1="18" x2="19" y2="18" />
        </SvgIcon>
    </IconButton>
);
